import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tooltip: {
		id: 'native-issue-table.common.error-cell.tooltip',
		defaultMessage: 'We couldn’t load this field’s details. Refresh and try again.',
		description: 'Tooltip shown when a field could not be shown in the table for an unknown reason',
	},
});
